//-----------------------------------------------------------------------
// Copyright © 2022 ManpowerGroup. All Rights Reserved.
//-----------------------------------------------------------------------

/* eslint-disable prettier/prettier */
import React, { useEffect, useContext, useState, useMemo } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { FooterActions } from "./footerActions";
import ErrorAlertMessage from "../common/alertMessages/errorAlertMessage";
import { Context } from "../common/context/Context";

const Footer = () => {
  const context = useContext(Context);
  const [errorAlert, setErrorAlert] = useState({
    showAlert: false
  })
  const showErrorModal = () => {
    let refErrorMessageAlert = JSON.parse(JSON.stringify(errorAlert));
    refErrorMessageAlert.showAlert = false;
    setErrorAlert(refErrorMessageAlert)
  }

  const fetchAdminCmsFooterLabel = (key) => {
    if (context?.adminNavigationCmsData?.Components && context?.adminNavigationCmsData?.Components["Footer.FooterText"]) {
      const adminFooterCmsData = context?.adminNavigationCmsData?.Components["Footer.FooterText"] || []
      return adminFooterCmsData?.Labels.find((x) => x.Key === key)?.Phrase || '';
    }
    return '';
  }

  const fetchAdminCmsFooterLogo = (key) => {
    if (context?.adminNavigationCmsData?.Components && context?.adminNavigationCmsData?.Components["Footer.FooterText"]) {
      const mediaList = context?.adminNavigationCmsData?.Components["Footer.FooterText"] || [];
      return mediaList?.MediaList.find((x) => x.Key === key)?.SmallImage?.ImageUrl || '';
    }
    return '';
  }
  const smallFooterLogoUrl = useMemo(() => fetchAdminCmsFooterLogo('Footer.FooterLogo'), [context?.adminNavigationCmsData]);


  return (
    <footer className="footer">
      <Container fluid>
        {errorAlert?.showAlert &&
          <ErrorAlertMessage alertMessage="AllPages.ErrorAlertMessage" showAlert={showErrorModal} />
        }
        <Row>
          <Col xs="6" md="4" lg="2" className="text-start">
            <div className="mt-0">
              <img src={smallFooterLogoUrl} className="img-fluid" alt="footer-image"></img>
            </div>
          </Col>
          <Col xs="6" className="text-end mt-lg-4 ms-auto">
            <p className="mb-0">
              <span href="/" className="">
                {fetchAdminCmsFooterLabel('Footer.RightsReserved')}
              </span>
            </p>
          </Col>
        </Row>
      </Container>
    </footer>
  )
};

export default Footer;
